import(/* webpackMode: "eager" */ "/var/www/html/tvfoco-headless/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/tvfoco-headless/src/app/Components/Ads/grumft-iab-ad.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/Ads/media-g-widget.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/Ads/post-mid-content-ads.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/tvfoco-headless/src/app/Components/Category/category.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/Others/client-push-notification-card.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/Posts/figcaption-toggle.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/Posts/post-content-with-ads.js");
